import EnemyType from "../../enums/EnemyType";
import EnemyData from "./EnemyDataInterface";

const EASY_ENEMYS: {
  [key in EnemyType]?: EnemyData[];
} = {
  [EnemyType.SMALL_HAMSTER1]: [
    {
      level: 1,
      maxHp: 0.1,
      speed: 130,
      power: 1.2,
      knockback: 1,
      deathKB: 2,
      xp: 1,
      killedAmount: 0,
      scale: 0.75,
      spriteName: "small_hamster1",
      animationKey: "small_hamster1_run",
    },
  ],
  [EnemyType.SMALL_HAMSTER2]: [
    {
      level: 1,
      maxHp: 0.1,
      speed: 150,
      power: 2,
      knockback: 1,
      deathKB: 2,
      xp: 1,
      killedAmount: 0,
      scale: 0.5,
      spriteName: "small_hamster2",
      animationKey: "small_hamster2_run",
    },
  ],
  [EnemyType.FAT_HAMSTER]: [
    {
      level: 1,
      maxHp: 1,
      speed: 150,
      power: 3,
      knockback: 1,
      deathKB: 2,
      xp: 1,
      killedAmount: 0,
      scale: 0.75,
      spriteName: "fat_hamster",
      animationKey: "fat_hamster_run",
    },
  ],
  [EnemyType.SCORPION]: [
    {
      level: 1,
      maxHp: 1,
      speed: 210,
      power: 8,
      knockback: 0,
      deathKB: 0,
      killedAmount: 0,
      xp: 1.5,
      spriteName: "scorpion",
      animationKey: "scorpion_run",
    },
  ],
  [EnemyType.SNAKE1]: [
    {
      level: 1,
      maxHp: 4,
      speed: 100,
      power: 8,
      knockback: 0.8,
      deathKB: 4,
      killedAmount: 0,
      xp: 2,
      spriteName: "snake1",
      animationKey: "snake1_run",
    },
  ],
  [EnemyType.SNAKE2]: [
    {
      level: 1,
      maxHp: 10,
      speed: 100,
      power: 10,
      knockback: 0.8,
      deathKB: 4,
      killedAmount: 0,
      xp: 2.5,
      spriteName: "snake2",
      animationKey: "snake2_run",
    },
  ],
  [EnemyType.CACTUS]: [
    {
      level: 1,
      maxHp: 7,
      speed: 120,
      power: 5,
      knockback: 1,
      deathKB: 5,
      killedAmount: 0,
      xp: 2,
      spriteName: "cactus",
      animationKey: "cactus_run",
    },
  ],
  [EnemyType.WARRIOR_HAMSTER]: [
    {
      level: 1,
      maxHp: 15,
      speed: 160,
      power: 15,
      knockback: 1,
      deathKB: 1,
      killedAmount: 0,
      xp: 2.5,
      spriteName: "warrior_hamster",
      animationKey: "warrior_hamster_run",
      scale: 0.75,
    },
  ],
};
export default EASY_ENEMYS;
